export const setData = (data, values, structureName) => {
  switch (structureName) {
    case "Financial":
      return {
        ...data,
        result: data.result.filter(
          (val) =>
            !data.result
              .filter((item) => item.rowId === values.rowId)
              .includes(val)
        ),
      };
    case "Structure":
      return {
        ...data,
        result: [...data.result],
      };
    case "ReasonCode": {
      const deletedIndex = data.result.findIndex(
        (item) => item.id === values.id
      );
      data.result.splice(deletedIndex, 1);
      return {
        ...data,
        result: data.result,
      };
    }
    default:
      return {
        ...data,
        result: data?.result ? [...data.result] : [],
      };
  }
};
